function timeout(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

// Async function to wait for a timeout
export async function asyncTimeout(fn: Function, ms: number) {
    await timeout(ms);

    return fn();
}
